import { Experiment } from '@amplitude/experiment-js-client'

let experimentClient = null
let initialized = false

export const getExperimentClient = () => {
  if (typeof window === 'undefined') return null
  if (experimentClient && initialized) return experimentClient

  const key = process.env.AMPLITUDE_API_KEY
  if (!key) return null

  experimentClient = Experiment.initializeWithAmplitudeAnalytics(key)
  initialized = true
  return experimentClient
}

// Export reset function for testing
export const resetExperimentClient = () => {
  experimentClient = null
  initialized = false
}

export default getExperimentClient
